import styled from "styled-components";
import {
  Scan3,
  ScanCongratulations,
  ScanLwwWide,
  ScanWon,
  ScanYouGot,
} from "../../assets/images";
import DatePicker from "./DatePicker";

const WinModal = ({ onApply, selected, promoData, onDateDataChange, date }) => {
  return (
    <StyledWinModal>
      <div>
        {/* <SpinWheelModalCow src={ScanCow} /> */}
        <ModalContent>
          <StyledLWWLogo src={ScanLwwWide} />
          <StyledCongratsImg src={ScanCongratulations} />
          <PromoName>
            <ScanGotImg src={ScanYouGot} />
            {selected.name}
          </PromoName>
          <PromoDescription>{selected.description}</PromoDescription>
          <ScanWonImageContainer>
            <ScanWonImg src={ScanWon} />
          </ScanWonImageContainer>
          {promoData.discountType === "product" ? (
            <DatePicker
              date={date}
              onDateDataChange={onDateDataChange}
              promoData={promoData}
            />
          ) : (
            <>
              <PromoLabel>PROMOCODE</PromoLabel>
              <PromoCode>{promoData.codeInLowerCase}</PromoCode>
            </>
          )}
          <ApplyPromo
            disabled={promoData.discountType === "product" && !date}
            onClick={() => onApply(promoData?.discountType)}
          >
            Redeem Offer
          </ApplyPromo>
          <LicenseText>
            LICENSE: {process.env.REACT_APP_SPIN_WHEEL_LICENSE}
          </LicenseText>
        </ModalContent>
      </div>
    </StyledWinModal>
  );
};

const LicenseText = styled.div`
  color: white;
  text-align: center;
  padding: 0 1rem;
  font-size: 0.6rem;
  z-index: 1;
  opacity: 0.3;
`;

const PromoName = styled.div`
  color: #ffc923;
  width: 100%;
  border-radius: 0.5rem;
  box-sizing: border-box;
  font-size: 1.75rem;
  position: relative;
  padding-top: 1.5rem;
`;
const PromoDescription = styled.div`
  color: white;
  width: 100%;
  border-radius: 0.5rem;
  box-sizing: border-box;
  font-size: 1rem;
`;
const PromoLabel = styled.div`
  color: white;
  padding: 0.5rem 0;
`;
const PromoCode = styled.div`
  color: #ffc923;
  padding: 0.5rem;
  border: 2px solid #ffc923;
  width: 100%;
  border-radius: 0.5rem;
  box-sizing: border-box;
  font-size: 1.5rem;
`;

const ScanGotImg = styled.img`
  width: 6.5rem;
  position: absolute;
  top: 0rem;
  left: 2rem;
  z-index:-1;
`;

const ScanWonImg = styled.img`
  width: 62.5%;
  position: absolute;
  inset: 0;
  margin: auto;
  z-index:-1;
`;

const ScanWonImageContainer = styled.div`
  height: 32.5vh;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ApplyPromo = styled.button`
  padding: 0.75rem;
  background: #55038d;
  border: none;
  color: white;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  width: 100%;
  margin: 1rem 0;
  margin-bottom:0.5rem;
  &:disabled {
    cursor: not-allowed;
  }
`;

const StyledLWWLogo = styled.img`
  width: 70%;
`;
const StyledCongratsImg = styled.img`
  width: 67.5%;
`;
const StyledWinModal = styled.div`
  height: 100vh;
  max-height: 100vh;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 1);
  > div {
    overflow: scroll;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url(${Scan3});
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 9;
  }
`;

const ModalContent = styled.div`
  padding: 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom:0;
`;

export default WinModal;
